import {_, React, observer, observable, computed, action, useLocalStore, Fragment} from '@api'
import {} from '@stores'
import {CardFieldStoreContext, CardFieldContextMenuItems, ContextMenuItem, useNestedCardItemsStore} from '@modules'
import {icons} from '@stores/ui'
import * as css from './NestedCardItemContextMenu.css'

/// region Store

export class NestedCardItemContextMenuStore {
  constructor() {
  }
}

export const NestedCardItemContextMenuStoreContext = React.createContext<NestedCardItemContextMenuStore>(null)
export const useNestedCardItemContextMenuStore = () => React.useContext(NestedCardItemContextMenuStoreContext)

/// endregion

/// region Components

export const NestedCardItemContextMenu = observer(function NestedCardItemContextMenu() {
  const {cardFieldStore: {editable, isArray, field, titleText, removeNestedItem}, contextMenu, catalog} = useNestedCardItemsStore(),
    {extra: {data}} = contextMenu

  console.log({data, field})
  return (
    <Fragment>
      {editable && <Fragment>
        {false && isArray && <ContextMenuItem icon={icons.add} text={`Add '${catalog.labelForField(field)}'...`} >
            <ContextMenuItem text='List of library items' />
          {/*<SpecList selectedData={data}/>*/}
        </ContextMenuItem>}

	  </Fragment>}
      <CardFieldContextMenuItems/>
    </Fragment>
  )
});

/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/product/productCard/components/BuilderCard/NestedCardItems/NestedCardItemContextMenu.tsx